
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("44FvL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $8EyOs = parcelRequire("8EyOs");


var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $jMyy4 = parcelRequire("jMyy4");


var $aJv6Q = parcelRequire("aJv6Q");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $qP1yw = parcelRequire("qP1yw");








var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $02b5fb906cf465ad$var$styling = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '1px',
    height: '16px',
    marginBlock: 'space.0',
    marginRight: 'space.050',
    marginLeft: 'space.100',
    alignSelf: 'center'
});
const $02b5fb906cf465ad$export$9bdbf4502c13e864 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "vertical-line",
            xcss: $02b5fb906cf465ad$var$styling
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};


const $a8f24b4bd469814d$export$f29be0a8efdebc38 = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { contentId: contentId, isDraft: isDraft, hasSeparator: hasSeparator } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== isDraft) {
        t1 = {
            fetchPolicy: "cache-and-network",
            variables: {
                contentId: contentId,
                isDraft: isDraft,
                format: "USER_FRIENDLY"
            }
        };
        $[0] = contentId;
        $[1] = isDraft;
        $[2] = t1;
    } else t1 = $[2];
    const { data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), t1);
    if (!data) return null;
    const lastUpdatedInfo = data?.singleContent?.contentStateLastUpdated?.value;
    const contentState = data?.singleContent?.contentState;
    let t2;
    if ($[3] !== contentId || $[4] !== contentState || $[5] !== hasSeparator || $[6] !== isDraft || $[7] !== lastUpdatedInfo) {
        t2 = contentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qP1yw.LazyRendererContentStateComponent), {
            contentId: contentId,
            contentState: contentState,
            lastUpdatedInfo: lastUpdatedInfo,
            isDraft: isDraft
        }), !isDraft && hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02b5fb906cf465ad$export$9bdbf4502c13e864), null));
        $[3] = contentId;
        $[4] = contentState;
        $[5] = hasSeparator;
        $[6] = isDraft;
        $[7] = lastUpdatedInfo;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $c0urc.ReloadType).content
        ];
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== refetch) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: t3,
            reload: refetch
        });
        $[10] = refetch;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t2 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t2, t4);
        $[12] = t2;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
const $a8f24b4bd469814d$export$cbe74da24be93fbd = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($a8f24b4bd469814d$export$f29be0a8efdebc38);
module.exports["RendererContentStateImpl"] = $a8f24b4bd469814d$export$f29be0a8efdebc38;
module.exports["RendererContentState"] = $a8f24b4bd469814d$export$cbe74da24be93fbd;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<2f2dfe426bd1e7dfe41d164e303a602e>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("brCZU"))).EditorContentStateComponent;
    }
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("9EUwJ"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("dzxx6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");

const $62a49c8d20755563$var$loadingPlaceholderBaseStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100'
});
const $62a49c8d20755563$var$placeHolderBackroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    height: '12px',
    width: '12px',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$StyledBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81b3y _1kl71qn1 _1e0c1o8l _1bsbt94y _4t3i7vkz _1wpz1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentState: contentState, isDraft: isDraft } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const t1 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles : $62a49c8d20755563$var$placeHolderBackroundColorStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $62a49c8d20755563$var$loadingPlaceholderBaseStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const contentStateLoadingPlaceholderStyles = t2;
    const t3 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles : $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles;
    let t4;
    if ($[2] !== t3) {
        t4 = [
            t3
        ];
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const contentStateColorPlaceholderStyles = t4;
    const t5 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-placeholder" : "renderer-content-state-placeholder";
    const t6 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-color-placeholder" : "renderer-content-state-color-placeholder";
    let t7;
    if ($[4] !== contentStateColorPlaceholderStyles || $[5] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: contentStateColorPlaceholderStyles,
            testId: t6
        });
        $[4] = contentStateColorPlaceholderStyles;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    const t8 = contentState?.name;
    let t9;
    if ($[7] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t8);
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== contentStateLoadingPlaceholderStyles || $[10] !== t5 || $[11] !== t7 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            as: "li",
            alignItems: "center",
            xcss: contentStateLoadingPlaceholderStyles,
            testId: t5
        }, t7, t9);
        $[9] = contentStateLoadingPlaceholderStyles;
        $[10] = t5;
        $[11] = t7;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== isDraft) {
        t11 = !isDraft && !(0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$StyledBorder, {
            "data-testid": "placeholder-vertical-line"
        });
        $[14] = isDraft;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, t10, t11);
        $[16] = t10;
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    return t12;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("brCZU", function(module, exports) {

let $8550776e254600f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8550776e254600f3$var$load("hHy5c"),
    $8550776e254600f3$var$load("er7wn"),
    $8550776e254600f3$var$load("gtxmI"),
    $8550776e254600f3$var$load("jrkRK"),
    $8550776e254600f3$var$load("6wr18"),
    $8550776e254600f3$var$load("3dFwk"),
    $8550776e254600f3$var$load("6jIfS"),
    $8550776e254600f3$var$load("43ztj"),
    $8550776e254600f3$var$load("h4Nf7"),
    $8550776e254600f3$var$load("fuKGN"),
    $8550776e254600f3$var$load("4IYLb"),
    $8550776e254600f3$var$load("Wowvf"),
    $8550776e254600f3$var$load("kHOMt"),
    $8550776e254600f3$var$load("dRpV3"),
    $8550776e254600f3$var$load("ffEVr"),
    $8550776e254600f3$var$load("7EorR"),
    $8550776e254600f3$var$load("dTsOE"),
    $8550776e254600f3$var$load("hhss7"),
    $8550776e254600f3$var$load("iqKwT"),
    $8550776e254600f3$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("9EUwJ", function(module, exports) {

let $7083b28f0e74da40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7083b28f0e74da40$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});


//# sourceMappingURL=RendererContentState.ca5aa5f5.js.map
